import React, { useEffect, useState } from "react";
import Link from "next/link";
import { checkIsFromDashboard, inIframe } from "../../utils/helpers";
import Router from "next/router";

type BreadcrumbProps = {
  items?: any;
  maxWidth?: string;
  visibility?: any;
};
const BreadcrumbComponent = ({
  items,
  maxWidth,
  visibility,
}: BreadcrumbProps) => {
  const [hideBreadcrumb, setHideBreadcrumb] = useState(Boolean);

  useEffect(() => {
    setHideBreadcrumb(checkIsFromDashboard(Router));

    if (inIframe() || visibility) {
      setHideBreadcrumb(true);
    }
  });

  const Separator = (item) => {
    if (item.children === items.length) {
      return <React.Fragment />;
    } else {
      return (
        <div className="separator">
          &gt;
          <style jsx>{`
            .separator {
              margin: 0 5px;
            }
          `}</style>
        </div>
      );
    }
  };
  return (
    <React.Fragment>
      {!hideBreadcrumb && (
        <div className="breadcrumb-wrapper">
          <div className="breadcrumb-container">
            {items?.map((item, key) => {
              if (item.page) {
                return (
                  <Link href={item.href} as={item.to} key={key}>
                    <a>
                      <div className="breadcrumb-item ">
                        <div>{item.page}</div>
                        <Separator>{items.indexOf(item) + 1}</Separator>
                      </div>
                    </a>
                  </Link>
                );
              }
            })}
          </div>
        </div>
      )}

      <style jsx>{`
        .breadcrumb-wrapper {
          display: flex;
          margin: 16px;
          justify-content: center;
        }
        .breadcrumb-container {
          display: flex;
          max-width: ${maxWidth ? maxWidth : "940px"};
          width: 100%;
          flex-flow: wrap;
        }
        .breadcrumb-item {
          display: flex;
          font-size: 14px;
          color: var(--color-gray);
        }
        .breadcrumb-item:hover {
          cursor: pointer;
        }

        @media only screen and (max-width: 600px) {
          .breadcrumb-wrapper {
            margin: 8px;
          }
          .breadcrumb-item {
            font-size: 10.5px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};
export default BreadcrumbComponent;
